import { ApiLocalStorage } from './ApiLocalStorage';

export const ToogleWhatsappResend = async (enabled = false) => {
  const currentStyle = (await ApiLocalStorage.get('theme')) || {};
  const updateStyle = {
    ...currentStyle,
    commons: {
      ...currentStyle.commons,
      secondSend: enabled,
    },
  };

  await ApiLocalStorage.set('theme', updateStyle);
};
